export const QUERY_CONSTANTS = {
    STALE_TIME: 10 * 60 * 1000,
    REFETCH_INTERVAL: 30 * 60 * 1000,
};